angular.module('account.settings')
    .component('accountSettingsICalComponent', {
        templateUrl: 'app/account/settings/ical.html',
        controller: function ($location, ICalendar, modals) {
            this.$onInit = () => {
                this.port = ($location.port() !== 443 && $location.port() !== 80) ? (":" + $location.port()) : ""

                ICalendar.get().$promise
                    .then(data => {
                        this.item = data
                        this.calendarLink = $location.host() + this.port + "/crm/ical/" + this.item.uuid
                    })
                    .catch(() => {
                        this.item = {}
                    })
            }

            this.regenerate = () => {
                ICalendar.regenerate().$promise.then(result => {
                    this.item = result
                    this.calendarLink = $location.host() + this.port + "/crm/ical/" + this.item.uuid
                })
            }

            this.remove = () => {
                let content = "Usunięcie konfiguracji spowoduje nieodwracalne zablokowanie synchronizacji w powiązanych urządzeniach. "
                content += "<b>Czy na pewno chcesz usunąć aktualną konfigurację iCalendar?</b>"
                modals.confirm(content, () => ICalendar.delete({uuid: this.item.uuid}).$promise.then(() => this.$onInit()))
            }
        }
    })
